@if (selectedRelatedRecipients?.length > 0) {
  <div
    class="assets">
    <div
      class="asset-recipients"
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <div
        fxLayout="row"
        fxLayoutAlign="start center">
        <topo-checkbox
          [checked]="includeRelatedRecipients"
          [indeterminate]="partialIncludeRelatedRecipients"
        (checkChanged)="onIncludeRelatedRecipientsChanged()"></topo-checkbox>
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          <div>{{ 'COMMUNICATIONS.RELATED-RECIPIENTS' | translate }}</div>
          <div class="total-counter">
            {{ relatedRecipientCount }}
          </div>
        </div>
      </div>
    </div>
    @for (relatedRecipient of selectedRelatedRecipients; track relatedRecipient.uId; let last = $last) {
      <div>
        <div
          class="layer-group"
          [ngClass]="{ 'last-in-child': last }">
          <div
            fxLayout="row"
            fxLayoutAlign="space-between start center">
            <div
              fxLayout="row"
              fxLayoutAlign="start center">
              <div>
                <topo-checkbox
                  [checked]="relatedRecipient.include"
                  [indeterminate]="isPartialSelected(relatedRecipient)"
                (checkChanged)="onRelatedRecipientSelectedChanged(relatedRecipient, $event)"></topo-checkbox>
              </div>
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                (click)="onManageRecipient(relatedRecipient.uId)">
                <div
                  class="asset-icon">
                  @if (!relatedRecipient.isCustomIcon) {
                    <div
                      class="asset-icon"
                      fxLayout="row"
                      fxLayoutAlign="space-around center"
                      [style]="'background-color:' + (relatedRecipient.color || '#FFFFFF') + ';color: #FFFFFF'">
                      <div
                        class="material-icons"
                        style="font-size: 16px">
                        {{ relatedRecipient.relatedAssetIcon }}
                      </div>
                    </div>
                  }
                  @if (!!relatedRecipient.isCustomIcon) {
                    <div
                      class="asset-icon"
                      fxLayout="row"
                      fxLayoutAlign="space-around center"
                      [style]="'background-color:' + (!lay ? '#FFFFFF' : relatedRecipient.color) + ';color: #FFFFFF'">
                      <img
                        [src]="relatedRecipient.datasetIcon | safeUrl"
                        style="width: 16px; height: 16px; margin: 4px 0px 0px 4px" />
                    </div>
                  }
                </div>
                <div class="asset-name ml-2">
                  {{ relatedRecipient.datasetName }}
                </div>
                <div class="asset-count ml-1">
                  @if (relatedRecipient.hasDocumentFilter == true) {
                    <span>({{ relatedRecipient.documentCount?.total }})</span>
                  }
                  @if (relatedRecipient.hasDocumentFilter != true) {
                    <span>({{ getRelatedSelectedCount(relatedRecipient) }}/{{ relatedRecipient.documentCount?.total }})</span>
                  }
                  @if (!!!relatedRecipient.documentCount?.contactCount) {
                    <span
                      class="no-count-warning-text">
                      <i class="icon icon-small_solid_warning no-count-warning"></i>
                      {{ 'COMMUNICATIONS.NO-TOTAL-CONTACTS' | translate }}
                    </span>
                  }
                  @if (!!relatedRecipient.documentCount?.contactCount) {
                    <span
                      class="contact-count">
                      &nbsp; {{ 'COMMUNICATIONS.TOTAL-CONTACTS' | translate : { number: relatedRecipient.documentCount?.contactCount } }}
                    </span>
                  }
                </div>
              </div>
            </div>
            @if (relatedRecipient.hasDocumentFilter !== true) {
              <div
                class="asset-actions"
                fxLayoutGap="12px">
                <i
                  class="icon icon-small_edit"
                  (click)="onManageRecipient(relatedRecipient.uId)"
                title="{{ 'COMMUNICATIONS.BUTTONS.EDIT' | translate }}"></i>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}

<topo-comms-related-assets-recipients-selection-list
  [activeContext]="listSelectActiveContext"
  [getSelectedUIds]="getListSelectedUIds"
  (recipientsSelected)="listSelectRecipientsSelected($event)"
(recipientsSelectionClosed)="listSelectClosed()"></topo-comms-related-assets-recipients-selection-list>
